import determineKeyMaker from 'utils/functions/determineKeyMaker.util';
import logger from 'utils/logger.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';

const L = logger('withCachedPromise');

const withCachedPromise = (fn, keymaker = determineKeyMaker()) => {
  if (isNotFn(fn)) throw new TypeError(L.error('()', 'fn is not a function'));
  if (isNotFn(keymaker)) throw new TypeError(L.error('()', 'keymaker is not a function'));

  const cache = new Map();

  const memoFn = async (...args) => {
    let key = null;

    try {
      // noinspection ES6RedundantAwait
      key = await keymaker(args);

      if (cache.has(key)) {
        // if there is already call in progress for the given args, we re-use that promise
        const promise = cache.get(key);

        L.debug('memoFn()', `size: ${cache.size}, key: ${key}`, 'args:', args, 'cache:', cache);

        return await promise; // await is needed to allow for proper error propagation
      }

      // this memoization works for async functions
      // be quick to set the promise as a flag before another one comes along
      const promise = fn(...args);
      cache.set(key, promise);

      return await promise; // await is needed to allow for proper error propagation
    } finally {
      if (key) {
        // cache invalidation criteria: the call ends with either success or error
        cache.delete(key);
        key = null;
      }
    }
  };

  Object.defineProperties(memoFn, {
    name: { value: `withCachedPromise(${fn.name || 'unknown'})` },
    length: { value: fn.length },
  });

  return memoFn;
};

// noinspection JSUnusedGlobalSymbols
export default withCachedPromise;
